"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputPure = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_native_listener_1 = tslib_1.__importDefault(require("react-native-listener"));
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
var utilities_1 = require("../typings/utilities");
var focus_1 = require("./focus");
/**
 * @internal
 */
var InputPure = /** @class */ (function (_super) {
    tslib_1.__extends(InputPure, _super);
    function InputPure() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.autofocusDispatcher = noop_1.default;
        _this.onChange = function (e) {
            _this.props.onChange(e.target.value, e);
        };
        _this.onKeyPress = function (e) {
            switch (e.keyCode) {
                case utilities_1.ENUM_KEY_CODE.KEY_CODE_ESCAPE:
                    if (_this.props.clearOnEsc) {
                        _this.onClear();
                    }
                    _this.props.onEscKeyPress();
                    break;
                case utilities_1.ENUM_KEY_CODE.KEY_CODE_ENTER:
                    _this.props.onEnterKeyPress();
                    break;
                default:
                    break;
            }
        };
        _this.onClear = function (e) {
            _this.props.onChange("", e);
        };
        return _this;
    }
    InputPure.prototype.componentDidMount = function () {
        var autofocus = this.props.autofocus;
        this.autofocusDispatcher = focus_1.runAutofocus(this.inputNodeRef, autofocus);
    };
    InputPure.prototype.componentWillUnmount = function () {
        this.autofocusDispatcher();
    };
    InputPure.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.autofocus !== this.props.autofocus) {
            this.autofocusDispatcher();
            this.autofocusDispatcher = focus_1.runAutofocus(this.inputNodeRef, this.props.autofocus);
        }
    };
    InputPure.prototype.getLabelClassNames = function (className) {
        return classnames_1.default({
            "gd-input": true,
            "gd-input-small": this.props.isSmall,
            "gd-input-search": this.props.isSearch,
            "gd-input-with-prefix": !!this.props.prefix,
            "gd-input-with-suffix": !!this.props.suffix,
            "gd-input-with-label": !!this.props.label,
            "gd-input-label-top": this.props.labelPositionTop,
            "has-error": this.props.hasError,
            "has-warning": this.props.hasWarning,
            "is-disabled": this.props.disabled,
        }, className);
    };
    InputPure.prototype.getInputClassNames = function () {
        return classnames_1.default({
            "gd-input-field": true,
            "gd-input-field-small": this.props.isSmall,
        });
    };
    InputPure.prototype.renderPrefix = function (prefix) {
        return prefix ? react_1.default.createElement("span", { className: "gd-input-prefix" }, prefix) : false;
    };
    InputPure.prototype.renderSuffix = function (suffix) {
        return suffix ? react_1.default.createElement("span", { className: "gd-input-suffix" }, suffix) : false;
    };
    InputPure.prototype.renderLabel = function (label) {
        return label ? react_1.default.createElement("span", { className: "gd-input-label" }, label) : false;
    };
    InputPure.prototype.renderSearch = function (isSearch) {
        return isSearch ? react_1.default.createElement("span", { className: "gd-input-icon gd-icon-search" }) : false;
    };
    InputPure.prototype.renderClearIcon = function (clearOnEsc) {
        return clearOnEsc && this.props.value.length > 0 ? (
        // react events use delegation and don't bubble, click on clear needs to be kept local
        // to avoid handling by overlay close handler and others
        react_1.default.createElement(react_native_listener_1.default, { onClick: this.onClear },
            react_1.default.createElement("span", { className: "gd-input-icon-clear gd-icon-clear s-input-clear" }))) : (false);
    };
    InputPure.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, clearOnEsc = _a.clearOnEsc, disabled = _a.disabled, isSearch = _a.isSearch, placeholder = _a.placeholder, prefix = _a.prefix, readonly = _a.readonly, suffix = _a.suffix, label = _a.label, maxlength = _a.maxlength, value = _a.value, onBlur = _a.onBlur, onFocus = _a.onFocus;
        return (react_1.default.createElement("label", { className: this.getLabelClassNames(className) },
            this.renderLabel(label),
            react_1.default.createElement("div", { className: "gd-input-wrapper" },
                react_1.default.createElement("input", { ref: function (ref) {
                        _this.inputNodeRef = ref;
                    }, className: this.getInputClassNames(), disabled: disabled, maxLength: maxlength, onChange: this.onChange, onBlur: onBlur, onFocus: onFocus, onKeyDown: this.onKeyPress, placeholder: placeholder, readOnly: readonly, value: value }),
                this.renderSearch(isSearch),
                this.renderClearIcon(clearOnEsc),
                this.renderPrefix(prefix),
                this.renderSuffix(suffix))));
    };
    InputPure.prototype.focus = function (options) {
        if (this.inputNodeRef) {
            this.inputNodeRef.focus(options);
        }
    };
    InputPure.defaultProps = {
        autofocus: false,
        className: "",
        clearOnEsc: false,
        disabled: false,
        hasError: false,
        hasWarning: false,
        isSearch: false,
        isSmall: false,
        maxlength: 255,
        onChange: noop_1.default,
        onEscKeyPress: noop_1.default,
        onEnterKeyPress: noop_1.default,
        onBlur: noop_1.default,
        onFocus: noop_1.default,
        placeholder: "",
        prefix: "",
        readonly: false,
        suffix: "",
        label: "",
        labelPositionTop: false,
        value: "",
    };
    return InputPure;
}(react_1.default.PureComponent));
exports.InputPure = InputPure;
//# sourceMappingURL=InputPure.js.map